<script lang="ts">
  import { orderBy } from 'es-toolkit'
  import PaneContent from '../../pane/PaneContent.svelte'
  import { ThreeItemKeys, ThreeItemTypes } from '../../../constants/three'
  import useObjectsQueries from '../../../routes/project/hooks/useObjectsQueries'
  import File from './File.svelte'
  import useFileQueries from '../../../routes/project/hooks/useFileQueries'
  import DraggableList from '../../DraggableList.svelte'

  const { printerId } = $props<{ printerId: string }>()
  const { useObjects } = useObjectsQueries()
  const { reorderFileMutation } = useFileQueries()
  const allObjects = useObjects()

  const fileIds = $derived.by(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    allObjects.dataUpdatedAt
    return orderBy(
      (allObjects.data ?? []).filter(
        item =>
          item.userData[ThreeItemKeys.ITEM_TYPE] === ThreeItemTypes.FILE
            && item.userData[ThreeItemKeys.ASSIGNED_PRINTER_ID] === printerId,
      ),
      [item => item.userData[ThreeItemKeys.PRINTING_ORDER]],
      ['asc'],
    ).map(item => item.uuid)
  })

  function handleReorder(detail: { from: number, to: number }) {
    const { from, to } = detail

    // Create new array with reordered items
    const newFileIds = [...fileIds]
    const [movedItem] = newFileIds.splice(from, 1)
    newFileIds.splice(to, 0, movedItem)

    // Update the printing order for all files
    newFileIds.forEach((fileId, newOrder) => {
      reorderFileMutation.mutate({ objectUuid: fileId, order: newOrder + 1 })
    })
  }
</script>

{#key allObjects.dataUpdatedAt}
  <PaneContent>
    <DraggableList
      items={fileIds}
      getKey={fileId => fileId}
      onreorder={handleReorder}
    >
      {#snippet children({ item: fileId })}
        <File
          {fileId}
          hidePrinterIndicator
          isDraggable
        />
      {/snippet}
    </DraggableList>
  </PaneContent>
{/key}
